

$(function () {
    var wizardSteps = [
        {
            id       : 'workers',
            selector : '#step-1',
            title    : 'Choose a Cleaner',
            validate : false,
            onNext   : null,
            onLoad   : handleWorkersLoad,  // only renders, never navigates
        },
        {
            id       : 'contact',
            selector : '#step-2',
            title    : 'Your Details',
            validate : true,
            onNext   : handleContactNext,
            onLoad   : null,
        },
        {
            id       : 'booking',
            selector : '#step-3',
            title    : 'Booking Details',
            validate : true,
            onNext   : handleBookingNext,
            onLoad   : handleBookingLoad,
        },
        {
            id       : 'payment',
            selector : '#step-4',
            title    : 'Payment',
            validate : false,
            onNext   : null,
            onLoad   : null,
        },
    ];

    if (!$('#smartwizard').length) return;

    var hideWorkerSelection = $('#smartwizard').data('hide-worker-selection') == 1;

    var wizard = $('#smartwizard').smartWizard({
        theme            : 'dots',
        selected         : hideWorkerSelection ? 1 : 0,
        autoAdjustHeight : false,
        toolbar          : { position: 'none' },
        keyboard         : { keyNavigation: false },
    });

    // Renumber visible step indicators when worker selection is hidden
    if (hideWorkerSelection) {
        var $visibleNavItems = $('#smartwizard .nav-progress .nav-item:not(.d-none)');
        $visibleNavItems.each(function (i) {
            $(this).find('.num').text(i + 1);
        });
    }

    function getStep(index) {
        return wizardSteps[index] || null;
    }

    function getStepIndexById(id) {
        return wizardSteps.findIndex(function (s) { return s.id === id; });
    }

    function updateWizardTitle(index) {
        var step = getStep(index);
        if (step) {
            $('.order-wizard-title').text(step.title);
        }
    }

    function validateStep(index) {
        var step = getStep(index);
        if (!step || !step.validate) return true;

        var isValid  = true;
        var $stepDiv = $(step.selector);
        $stepDiv.addClass('was-validated');

        var $chooseDuration = $stepDiv.find('#choose-duration');
        if ($chooseDuration.length) {
            $chooseDuration.find('input[type="radio"]').each(function (i, obj) {
                if (!obj.checkValidity()) isValid = false;
            });
        }

        $stepDiv.find('.form-control').each(function (i, obj) {
            if (!obj.checkValidity()) {
                isValid = false;
                var $group = $(obj).closest('.form-group');
                if ($group.find('.invalid-feedback').length) {
                    $group.find('.invalid-feedback').text(obj.validationMessage);
                } else {
                    $(obj).parent().append(
                        '<em id="' + $(obj).attr('name') + '-error" class="error invalid-feedback">'
                        + obj.validationMessage + '</em>'
                    );
                }
            }
        });

        return isValid;
    }

    function onStepActivated(index) {
        updateWizardTitle(index);

        var step = getStep(index);
        if (!step) return;

        if (index > 0) {
            $('#product_form').trigger('change');
        }

        $(document).off('product-builder-loaded.wizard').on('product-builder-loaded.wizard', function () {
            if (index > 0) {
                $('#product_form').trigger('change');
            }
            var $couponField = $('.order-coupon-field .coupon-code');
            if ($couponField.length && $couponField.val().length > 0) {
                applyCoupon($('.apply-coupon'));
            }
        });

        // ✅ Guard: only call onLoad for the workers step if we actually
        //    navigated TO it (not from it or through it)
        if (typeof step.onLoad === 'function') {
            step.onLoad(wizard, index);
        }
    }

    $('#smartwizard').on('showStep', function (e, anchorObject, stepIndex) {
        onStepActivated(stepIndex);
    });

    $('#prev-btn2').on('click', function () {
        wizard.smartWizard('prev');
    });

    $('#reset-btn2').on('click', function () {
        wizard.smartWizard('reset');
    });

    $('#next-btn2').on('click', function () {
        var state        = wizard.smartWizard('getStepInfo');
        var currentIndex = state.currentStep;
        var step         = getStep(currentIndex);

        if (!step) return;
        if (!validateStep(currentIndex)) return;

        var stepDiv = step.selector;
        if (typeof step.onNext === 'function') {
            console.log('Calling onNext for step:', step.id);
            step.onNext(wizard, stepDiv);
        } else {
            wizard.smartWizard('next');
        }
    });

    setTimeout(function () {
        var state        = wizard.smartWizard('getStepInfo');
        var currentIndex = state.currentStep;

        // ✅ Detect which step the URL hash is pointing to
        var hashStep = 0;
        var hash     = window.location.hash; // e.g. "#step-4"
        if (hash) {
            var match = hash.match(/step-(\d+)/);
            if (match) {
                hashStep = parseInt(match[1], 10) - 1; // convert to 0-based index
            }
        }

        var targetIndex = Math.max(currentIndex, hashStep);

        if (targetIndex === 0) {
            updateWizardTitle(0);
            return;
        }

        // ✅ Find the step marked as the gate/auth step by id — not hardcoded index
        var gateStepIndex = getStepIndexById('contact');
        if (gateStepIndex === -1) gateStepIndex = 0; // fallback if no contact step exists

        // Validate the gate step — if invalid, send back to it
        if (!validateStep(gateStepIndex)) {
            wizard.smartWizard('goToStep', gateStepIndex);
            updateWizardTitle(gateStepIndex);
            return;
        }

        // ✅ Jump directly to the target step — no API calls, no worker fetch
        wizard.smartWizard('goToStep', targetIndex);
        updateWizardTitle(targetIndex);

    }, 200);


    // ─────────────────────────────────────────────────────────────────────────
    //  SHARED UTILITIES
    // ─────────────────────────────────────────────────────────────────────────

    function enableRealTimeErrorCleanup(stepSelector) {
        $(stepSelector).off('input.wizardCleanup').on('input.wizardCleanup', function (e) {
            e.preventDefault();
            $(stepSelector).find('.form-control').each(function (i, obj) {
                if (e.target.validationMessage.length === 0) {
                    $(e.target).removeClass('is-invalid');
                    return true;
                }
                if ($(obj).parent().find('.invalid-feedback').length) {
                    $(obj).parent().find('.invalid-feedback').text(obj.validationMessage);
                } else {
                    $(obj).parent().append(
                        '<em id="' + $(obj).attr('name') + '-error" class="error invalid-feedback">'
                        + obj.validationMessage + '</em>'
                    );
                }
            });
        });
    }

    function renderValidationErrors(stepSelector, errors) {
        enableRealTimeErrorCleanup(stepSelector);
        var $elem = $(stepSelector);
        $.each(errors, function (key, value) {
            $elem.find("[name='" + key + "']").removeClass('is-valid').addClass('is-invalid');
            var $errorElem = $elem.find("[name='" + key + "']").closest('div').find('.error');
            if ($errorElem.length) {
                $errorElem.text(value[0]);
            } else {
                $elem.find("[name='" + key + "']").parent().append(
                    '<em id="' + key + '-error" class="error invalid-feedback">' + value[0] + '</em>'
                );
            }
        });
    }

    function showLoginPopup(message) {
        Swal.fire({
            title              : 'Welcome back!',
            html               : message,
            imageUrl           : url + '/storage/frontend/mask-happly.png',
            imageWidth         : 70,
            imageHeight        : 70,
            customClass        : { image: 'opacity-7' },
            input              : 'password',
            inputPlaceholder   : 'Enter your password',
            showCancelButton   : true,
            showDenyButton     : true,
            confirmButtonText  : 'Login',
            denyButtonText     : 'Email Login Link',
            cancelButtonText   : 'Cancel',
            showLoaderOnConfirm: true,
            showLoaderOnDeny   : true,

            preConfirm: function (password) {
                if (!password) {
                    Swal.showValidationMessage('Password required');
                    return false;
                }
                return fetch(url + '/ajax-login', {
                    method  : 'POST',
                    headers : {
                        'Content-Type' : 'application/json',
                        'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').content,
                    },
                    body: JSON.stringify({ email: $('#email').val(), password: password }),
                })
                .then(function (res) { return res.json(); })
                .then(function (data) {
                    if (!data.success) throw new Error(data.message);
                    return data;
                })
                .catch(function (err) {
                    Swal.showValidationMessage(err.message);
                });
            },

            preDeny: function () {
                return $.ajax({
                    url    : url + '/send-magic-link',
                    method : 'POST',
                    data   : {
                        email  : $('#email').val(),
                        _token : $('meta[name="csrf-token"]').attr('content'),
                    },
                })
                .then(function (response) {
                    if (response.status === 'success') {
                        Swal.fire({
                            icon             : response.status,
                            title            : 'Magic link sent!',
                            text             : response.message,
                            timer            : 3000,
                            showConfirmButton : false,
                        });
                    } else {
                        Swal.showValidationMessage(response.message || 'Failed to send magic link.');
                        return false;
                    }
                })
                .catch(function () {
                    Swal.showValidationMessage('Server error. Try again.');
                    return false;
                });
            },

        }).then(function (result) {
            if (result.isConfirmed) {
                Swal.fire({ icon: 'success', title: 'Logged in!', timer: 1000, showConfirmButton: false })
                    .then(function () { window.location.reload(); });
            }
        });
    }


    // ─────────────────────────────────────────────────────────────────────────
    //  STEP HANDLERS
    // ─────────────────────────────────────────────────────────────────────────

    function handleContactNext(wizard, stepDiv) {
        var payload = $(`${stepDiv} input`).serializeFormJSON();
        $.ajax({
            url    : url + '/api/can-proceed-to-step2',
            method : 'GET',
            data   : payload,
        })
        .then(function (response) {
            return {
                proceed : response.proceed,
                message : response.message,
                status  : response.status,
            };
        })
        .catch(function (res) {
            if (res.status === 422 && res.responseJSON && res.responseJSON.errors) {
                renderValidationErrors(stepDiv, res.responseJSON.errors);
                return { proceed: false };
            }
            Swal.fire({ icon: 'error', title: 'Error', text: 'Unable to verify email. Try again.' });
            return { proceed: false };
        })
        .then(function (res) {
            if (!res || !res.proceed) {
                if (res && res.status === 'error') {
                    Swal.fire({ icon: 'error', title: 'Oops', html: res.message });
                    return;
                }
                if (res && res.message) {
                    showLoginPopup(res.message);
                }
                return;
            }

            // ✅ Navigate to workers AND fetch workers — or skip straight to booking
            // fetchAndNavigateWorkers(wizard);
            wizard.smartWizard('next');
        });
    }

    /**
     * Fetches nearby workers.
     * On success  → renders list, navigates to workers step.
     * On empty    → navigates directly to booking step.
     *
     * ✅ This is the ONLY place goToStep is called for workers/booking navigation.
     *    handleWorkersLoad (the onLoad hook) only re-renders — it never navigates.
     */
    function fetchAndNavigateWorkers(wizard) {
        var nearbyUrl        = $('#nearby-fixworkers').data('url');
        var workersStepIndex = getStepIndexById('workers');
        var bookingStepIndex = getStepIndexById('booking');

        $.ajax({
            url    : nearbyUrl,
            method : 'GET',
            data   : {
                post_code   : $('#post_code').val(),
                geo_lat     : $('.geo_lat').val(),
                geo_long    : $('.geo_long').val(),
                best_nearby : true,
            },
        }).then(function (response) {
            if (response && response.length > 0) {
                renderWorkersList(response);
                wizard.smartWizard('goToStep', workersStepIndex);
            } else {
                $('#nearby-fixworkers').html('<p class="text-muted">No workers found nearby.</p>');
                wizard.smartWizard('goToStep', bookingStepIndex);
            }
        });
    }

    /**
     * WORKERS STEP — onLoad
     * ✅ Only re-renders the list if workers were already loaded.
     *    Never calls goToStep — that would cause the step-4 → step-2 loop.
     */
    function handleWorkersLoad(wizard, index) {
        var nearbyUrl = $('#nearby-fixworkers').data('url');

        // If the container already has content, don't re-fetch
        var $firstChild = $('#nearby-fixworkers').children().first();
        if ($firstChild.length && !$firstChild.hasClass('loading-fixworkers')) return;

        $.ajax({
            url    : nearbyUrl,
            method : 'GET',
            data   : {
                post_code   : $('#post_code').val(),
                geo_lat     : $('.geo_lat').val(),
                geo_long    : $('.geo_long').val(),
                best_nearby : true,
            },
        }).then(function (response) {
            if (response && response.length > 0) {
                renderWorkersList(response);
            } else {
                $('#nearby-fixworkers').html('<p class="text-muted">No workers found nearby.</p>');
                wizard.smartWizard('next');
            }
            // ✅ No goToStep here — we are already on the right step
        });
    }

    /** Renders the workers list HTML — shared by both fetch functions */
    function renderWorkersList(workers) {
        var html = '';
        workers.forEach(function (worker) {
            html += '<div class="list-card list-card-bg-hover d-flex w-100 pointer toggle-user-profile-card mt-0 mb-3 p-3 shadow-sm rounded"'
                  + ' href="' + url + '/profile-card/' + worker.uuid + '" data-toggle="ajax-modal">'
                  + '<div class="me-3">'
                  + '<img class="card-order-icon image-cover p-0 rounded-circle border" src="' + worker.image + '" height="64" width="64" alt="' + worker.name + '">'
                  + '</div>'
                  + '<div class="list-card-info flex-grow-1">'
                  + '<div class="list-card-title fw-bold fs-5">' + worker.name + '</div>'
                  + '<div class="list-card-message mt-2 d-flex text-muted">'
                  + '<div class="flex-fill text-left"><i class="fa-solid fa-star me-1"></i> ' + worker.total_reviews + ' Reviews</div>'
                  + '<div class="flex-fill text-left"><i class="fa-solid fa-location-dot me-1"></i> ' + worker.distance.toFixed(1) + ' km Away</div>'
                  + '<div class="flex-fill text-left"><i class="fa-solid fa-route me-1"></i> ' + worker.coverage + ' km Coverage</div>'
                  + '</div></div></div>';
        });
        html+= `<div class="text-center text-muted">
            <i class="fa-solid fa-circle-info"></i>
            If they are unavailable, other nearby experts will be automatically notified.
        </div>`;
        $('#nearby-fixworkers').html(html);
    }

    function handleBookingLoad(wizard) {
        $('#product_form').trigger('change');
    }

    function handleBookingNext(wizard, stepDiv) {
        var bookingStep = wizardSteps.find(function (s) { return s.id === 'booking'; });
        var actionUrl   = $('#next-btn2').attr('action');
        var mergedData  = {};

        wizardSteps.forEach(function (step) {
            if (step.selector && $(step.selector).length) {
                $.extend(mergedData, $(step.selector).serializeJSON());
            }
        });

        $.extend(mergedData, $('.order-coupon-field').serializeJSON());
        mergedData._token = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            url    : actionUrl,
            method : 'POST',
            data   : mergedData,

            success: function (data) {
                if (data.status === 'success') {
                    if (data.next_step === true) {
                        wizard.smartWizard('next');
                        $('.paymenr-button-placeholder').html('Pay ' + data.currency_symbol + ' ' + data.due);
                        $('.payment-form-status-overlay').toggle(data.due <= 0);
                    }
                    if (typeof data.next_step === 'string') {
                        beautify.redirect(data.next_step);
                    }
                } else {
                    beautify.notification(data.message, data.status);
                }
            },

            error: function (xhr) {
                var err = xhr.responseJSON;

                if (typeof err.next_step === 'string') {
                    wizard.smartWizard('next');
                }
                if (err.errors) {
                    renderValidationErrors(bookingStep.selector, err.errors);
                }
                if (err.message) {
                    beautify.notification(err.message, err.status || 'error');
                } else {
                    beautify.notification('Oops! Something went wrong, Please try again.', 'error');
                }
            },
        });
    }

});




$(function() {
    /**
     * --------------------------------------------------------------------------------------------
     * Card popup. dropdown on mobile device
     * --------------------------------------------------------------------------------------------
     */
    const dropdown = $("#dropdown-content");
    const overlay = $("#dropdown-content-overlay");
    const popup = $("#topPopup");
    const arrowIcon = dropdown.find(".fas"); // selects the arrow inside the dropdown

    dropdown.on("click", function (e) {
        e.stopPropagation();

        overlay.toggle();
        $("body").toggleClass("no-scroll");

        // Toggle arrow direction
        arrowIcon.toggleClass("fa-arrow-down fa-arrow-up");
    });


    // Clicking on overlay (backdrop) closes it
    overlay.on("click", function (event) {
        if (event.target === this) {
            overlay.hide();
            $("body").removeClass("no-scroll");
            arrowIcon.removeClass("fa-arrow-up").addClass("fa-arrow-down");
        }

    });



    // Show the coupon input field
    $(document).on('click', '.show-coupon-btn', function () {
        console.log("aaaaa");
        $('.order-coupon-btn').hide();
        $('.order-coupon-field').show().find('.coupon-code').focus();
    });

    // Reusable function
    function applyCoupon($triggerBtn) {
        let $field = $triggerBtn.closest('.order-coupon-field');
        let couponCode = $field.find('.coupon-code').val();
        let $button = $('.show-coupon-btn');

        // Prevent empty request
        if (!couponCode || couponCode.length === 0) {
            console.log('Coupon code is empty');
            return;
        }

        $.ajax({
            url: $triggerBtn.attr('action'),
            method: 'POST',
            data: {
                coupon_code: couponCode,
                product_id: $triggerBtn.data('product-id'),
                _token: csrf_token
            },
            success: function (data) {

                // Update button text
                $button.html(data.message);

                // Reset button classes
                $button.removeClass('btn-outline-secondary btn-outline-success btn-outline-warning');

                // Apply status class
                if (data.status === 'success') {
                    $button.addClass('btn-outline-success');
                } else {
                    $button.addClass('btn-outline-warning');
                }

                // Reset UI
                $('.order-coupon-btn').show();
                $('.order-coupon-field').hide();

                // Wizard handling
                var state = wizard.smartWizard("getStepInfo");
                if (state.currentStep == 3) {
                    handleWizardFormSubmittion(
                        $('#next-btn2').attr('action'),
                        state.currentStep
                    );
                }
            },
            error: function (xhr) {

                let message = xhr.responseJSON?.message || 'Something went wrong';

                $button.text(message);

                $button.removeClass('btn-outline-secondary btn-outline-success btn-outline-warning')
                       .addClass('btn-outline-warning');

                $('.order-coupon-btn').show();
                $('.order-coupon-field').hide();
            }
        });
    }

    // Click handler
    $(document).on('click', '.apply-coupon', function (e) {
        e.preventDefault();
        applyCoupon($(this));
    });

    /**
     * Show top right cart option if sticky cart available on the page
     */
    if($('.sticky-cart').length > 0){
        $('#dropdown-content').show();
    }

    $(document).on('input', '.coupon-code', function () {
        let value = $(this).val();
        // Update all other coupon inputs except the current one
        $('.coupon-code').not(this).val(value);
    });




});
